<template>
  <div class="d-flex">
    <baby-status-face
      :initialValue="state"
      :student="studentName"
      :title="title"
      @updatedElement="propagateChange"
      ref="element" />
  </div>
</template>
<script>
import BabyStatusFace from './BabyStatusFace.vue'
import BasicInputModal from './BasicInputModal.vue'
import {componentValues, getDataByValue} from '@/utils/componentsValue'

export default {
  components: { BabyStatusFace, BasicInputModal },
  created: function () {
    if (this.$attrs.student) this.state = this.$attrs.student.firstCourseValue
  },
  props: {
    title: {
      type: String,
      default: () => 'Primer Plato'
    },
    studentName: String
  },
  data: () => ({
    enabled: false,
    byDefault: 'mitad',
    state: '',
    items: componentValues.firstCourseValue
  }),
  methods: {
    getData: function () {
      return getDataByValue(this.items, this.state)
    },
    setValue: function (value) {
      this.state = value
      this.$refs.element.setValue(value)
    },
    setEnable: function (value) {
      this.enabled = value
      this.$refs.element.setEnable(value)
      this.enabled ? this.setValue(this.byDefault) : this.setValue('ausente')
    },
    propagateChange: function (item) {
      this.$emit('updatedElement',
        { firstCourseValue: item.value }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryElements/FirstCourseValue.vue